function Header() {
  return (
    <div>
      <h1>Welcome to Awesome Animal Translator</h1>
      <h2>
        - gather intercultural animal-understanding with this indispensable tool
        !
      </h2>
    </div>
  );
}

export default Header;
